import { render, staticRenderFns } from "./ResultsRevenueCard.vue?vue&type=template&id=84fac32c"
import script from "./ResultsRevenueCard.vue?vue&type=script&lang=js"
export * from "./ResultsRevenueCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports